import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Grid,
  Typography,
  Box,
  CircularProgress,
  Dialog,
  Button,
  Stack,
} from '@mui/material';
import { useSelector } from 'react-redux';
import IndividualPostOverlayAdmin from './individualPostOverlayAdmin';
import { toast } from 'react-toastify';

const PostAdmin = () => {
  const { userInfo } = useSelector((state) => state.userInfo);

  const [posts, setPosts] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [postData, setPostData] = useState(null);
  const [openPost, setOpenPost] = useState(false);
  const [username, setUsername] = useState(null);
  const [payload, updatePayload] = useState([]);
  const [loadingUpdates, setLoadingUpdates] = useState(false);
  const fetchPosts = () => {
    setLoading(true);

    if (username) {
      axios
        .get(
          `https://soapboxapi.megahoot.net/upload/admin/post?page=${pageIndex}&&username=${username}`
        )
        .then((res) => {
          if (res.data && res.data.results) {
            setPosts(res.data.results); // replace instead of append
            setHasMore(res.data.results.length === 10); // only has more if full page
          }
        })
        .catch((error) => console.error('Error fetching posts:', error))
        .finally(() => setLoading(false));
    } else {
      axios
        .get(
          `https://soapboxapi.megahoot.net/upload/admin/post?page=${pageIndex}`
        )
        .then((res) => {
          if (res.data && res.data.results) {
            setPosts(res.data.results); // replace instead of append
            setHasMore(res.data.results.length === 10); // only has more if full page
          }
        })
        .catch((error) => console.error('Error fetching posts:', error))
        .finally(() => setLoading(false));
    }
  };

  const saveUpdatedPostHandler = async () => {
    try {
      // `payload` is your array of objects built via addToUpdateHandler
      // Example: [{ id: 1, authorEmail: "...", authorUsername: "..." }, ...]
      setLoadingUpdates(true);
      if (!payload || payload.length === 0) {
        console.warn('No updates to send');
        return;
      }

      const response = await axios.post(
        `https://soapboxapi.megahoot.net/upload/update-posts`,
        { posts: payload } // send as body
      );

      toast.success('posts updated successfully');
      // optional: clear payload after success
      updatePayload([]);
      setLoadingUpdates(false);
    } catch (error) {
      toast.error('Error updating posts:');
      setLoadingUpdates(false);
    }
  };

  useEffect(() => {
    console.log(payload);
  }, [payload]);

  useEffect(() => {
    fetchPosts();
  }, [pageIndex, userInfo]);

  return (
    <div
      style={{
        height: '100vh',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div style={{ width: '85vw', marginTop: '100px' }}>
        {/* Pagination Controls */}
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Button
            variant="contained"
            disabled={pageIndex === 1}
            onClick={() => setPageIndex((prev) => Math.max(1, prev - 1))}
          >
            Previous
          </Button>

          <Stack direction="row">
            <input
              placeholder=" Search By Username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
              }}
            />
            <Button sx={{ ml: 1 }} onClick={fetchPosts} variant="contained">
              Fetch Posts
            </Button>
          </Stack>
          <Stack direction="row" gap={1}>
            <Button variant="contained" onClick={saveUpdatedPostHandler}>
              Save
            </Button>
            <Button
              variant="contained"
              onClick={() => setPageIndex((prev) => prev + 1)}
            >
              Next
            </Button>
          </Stack>
        </Box>

        <div style={{ marginTop: 20, marginBottom: '100px' }}>
          <h3>
            {posts.length} Posts - Page {pageIndex}
          </h3>

          {loading ? (
            <Box display="flex" justifyContent="center" my={4}>
              <CircularProgress />
            </Box>
          ) : posts.length === 0 ? (
            <Typography variant="body2" align="center" color="textSecondary">
              No posts found
            </Typography>
          ) : (
            <Grid container spacing={2}>
              {posts.map((post) => (
                <Grid item xs={12} sm={6} md={3} key={post.id}>
                  <IndividualPostOverlayAdmin
                    postData={post}
                    setPosts={setPosts}
                    updatePayload={updatePayload}
                    forceClose={() => {
                      setOpenPost(false);
                      setPostData(null);
                    }}
                  />
                </Grid>
              ))}
            </Grid>
          )}
        </div>
      </div>
      {loadingUpdates && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            bgcolor: 'rgba(0,0,0,0.5)',
            zIndex: 2000, // higher than dialogs
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircularProgress size={60} sx={{ color: 'white' }} />
        </Box>
      )}
    </div>
  );
};

export default PostAdmin;
